/**
 * Me → Friends sub-page (P1.6 — empty-state only; real data ships P2).
 */

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MeSubpageShell } from '../../components/chrome/MeSubpageShell';
import { EmptyState } from '../../components/me/EmptyState';

export function Friends(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation('me');
  return (
    <MeSubpageShell title={t('sections.friends')} data-testid="friends-page">
      <EmptyState
        title={t('friends.emptyTitle')}
        body={t('friends.emptyBody')}
        glyph="✧"
        ctaLabel={t('openHome')}
        onCta={() => void navigate('/home')}
        data-testid="friends-empty"
      />
    </MeSubpageShell>
  );
}
